import React from 'react';
import styles from './ShareButton.scss';
import CSSModules from 'react-css-modules';
import shareIcon from './images/share-icon.svg';

export interface Props {
  handleShareClick: () => void;
  displayShareButtonIcon: boolean;
}

const ShareButton: React.StatelessComponent<Props> = ({
  handleShareClick,
  displayShareButtonIcon,
}) => {
  const handleShareButtonClick = () => {
    handleShareClick();
  };

  return (
    <button
      type="button"
      className="jg-btn jg-btn--ghost"
      styleName="share-button"
      onClick={() => handleShareButtonClick()}
    >
      {displayShareButtonIcon && <img src={shareIcon} alt="Share" />}
      Share
    </button>
  );
};

export default CSSModules(ShareButton, styles);



// WEBPACK FOOTER //
// ./src/components/ShareModal/ShareButton.tsx